import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};
type ReturnTuple = [
  response: vp.PortalClientLoginHistoryResponse,
  request: (requestParams: vp.PortalClientLoginHistoryRequest) => void,
  reset: () => void,
];

function usePostPortalClientLoginHistory({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.PortalClientLoginHistoryRequest>({
    BrowserName: '',
    BrowserVersion: '',
    City: '',
    Country: '',
    BrowserEngineName: '',
    BrowserEngineVersion: '',
    Hostname: '',
    IPAddress: '',
    Location: '',
    Organization: '',
    OSName: '',
    OSVersion: '',
    OSVersionName: '',
    PlatformType: '',
    PlatformVendor: '',
    PostalCode: '',
    Region: '',
    TimeZone: '',
    Username: '',
    RefferingUrl: '',
    RawUserAgent: '',
  });
  const [response, setResponse] = useState<vp.PortalClientLoginHistoryResponse>({
    Success: false,
    ErrorMessage: '',
    SuspiciousLogin: false,
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postPortalClientLoginHistory(params, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: vp.PortalClientLoginHistoryRequest) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        SuspiciousLogin: false,
      });
      setSendRequest(false);
    },
  ];
}
export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostPortalClientLoginHistory);
